/**
 * WHAT: React application entry point that mounts the App component into the DOM.
 * WHY:  Bootstraps the DAMA single-page application with StrictMode enabled for
 *       development warnings, and initializes optional web-vitals performance reporting.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';  // UAR Professional Theme
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
